import Component from 'vue-class-component';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeDestroy',
]);
